import { join } from "es-toolkit/compat";

const component = "SiteTreeStructure";

export const siteTreeStructure = {
  component,
  searchTextInput: join(component, "search-text-input"),
} as const;
